import React, { useState, useEffect } from 'react';

//********************************Componentes Generales******************************************* */
import Card from '../../../../../Components/Card/Card';
import { toastShow } from '../../../../../Services/ToastService';
import { useForm } from '../../../../../Hooks/useForm'


///**********************Componentes PrimeReact******************************************** */

import { Button } from 'primereact/button';
import {confirmDialog } from 'primereact/confirmdialog';
import { classNames } from 'primereact/utils'
import { Image } from 'primereact/image';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
//*****************************Consultas API*************************************************************** */
import {getInfoProducto, putInfoProducto } from '../../../../../API/Global/ProductosSuministros/ProductosSuministrosRequest'

import { getCategoriasFinanzas } from '../../../../../API/Global/CategoriaFinanzas/CategoriasFinanzas'
import { getSubCategoriasFinanzas } from '../../../../../API/Global/SubCategoriaFinanzas/SubCategoriaFinanzasRequest'
import { width } from '@mui/system';


const ProductoTab = ({ IdProducto, toast, hideDialog, refresh = () => { }, setNombreProducto }) => {

    const [loading, setLoading] = useState(false)
    const [categoriasFinanzas, setCategoriasFinanzas] = useState([])
    const [subCategoriasFinanzas, setSubCategoriasFinanzas] = useState([]);
    const [subCategoriasFiltradas, setSubCategoriaFiltradas] = useState([]);
    const [showMessages, setShowMessages] = useState({ error: false });
    const [imgProducto, setImgProducto] = useState([]);
    const { values, setValues, handleChange, handleInputChange, resetForm } = useForm({
        IdProductoSuministro: -100,
        CodigoProducto: '',
        NombreProducto: '',
        IdCategoriaFinanzas: -10,
        CategoriaFinanzas: '',
        IdSubCategoriaFinanzas: -10,
        SubCategoriaFinanzas: '',
        IdEstado: 1
    })

    const obtenerInformacion = async () => {

        const tempoCate = await getCategoriasFinanzas()
        setCategoriasFinanzas(tempoCate)

        const tempoSub = await getSubCategoriasFinanzas()
        setSubCategoriasFinanzas(tempoSub)
        setSubCategoriaFiltradas(tempoSub)

        if (IdProducto > 0) {
            const tempoProducto = await getInfoProducto(IdProducto)
            setNombreProducto(tempoProducto[0]?.NombreProducto)
            setValues(tempoProducto[0])
            // if (tempoProducto[0]?.TieneImagen) {
            //     const tempoI = await getImagenProductoServer(tempoProducto[0].CodigoProducto);
            //     setImgProducto(tempoI?.base64Image)
            // }

            if (tempoProducto[0]?.IdCategoriaFinanzas > 0) {
                let tempoSubCategoria = tempoSub.filter((e) => e.IdCategoriaFinanzas === tempoProducto[0]?.IdCategoriaFinanzas)
                setSubCategoriaFiltradas(tempoSubCategoria)
            }
            setLoading(true)
            setLoading(false)
        }
    }

    useEffect(() => {
        if (IdProducto > 0) {
            obtenerInformacion()
            setImgProducto(null);
        } else {
            setShowMessages({ error: false })
            resetForm({})
        }
    }, [IdProducto])



    const verificarCampo = () => {
        let errors = {}
        let isValid = true

        if (!values.IdCategoriaFinanzas) {
            errors.IdCategoriaFinanzas = true
            errors.General = true
            isValid = false
        }

        if (!values.IdSubCategoriaFinanzas) {
            errors.IdSubCategoriaFinanzas = true
            errors.General = true
            isValid = false
        }

        setShowMessages({ ...errors, error: !isValid });
        if (Object.keys(errors).length === 0 && isValid) {
            return false
        } else {
            return true
        }

    }

    const ImagenProducto = () => {

        if (imgProducto) {
            // var binary = '';
            // var bytes = [].slice.call(new Uint8Array(imgProducto.data));
            // bytes.forEach((b) => binary += String.fromCharCode(b));
            // const base64String = window.btoa(binary);
            return (
                <div className='d-flex flex-row' style={{ justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }} >
                    <Image src={`data:image/jpeg;base64,${imgProducto}`} alt="Image" width="150" height='150' />
                </div>
            )
        } else {
            return (
                <div className='d-flex flex-row' style={{ justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }} >
                    <h3 style={{ fontWeight: 'bold' }}>Imagen No Disponible</h3>
                </div>
            )
        }

    }

    const GuardarInformacion = () => {
        const verificacion = verificarCampo()

        if (verificacion) {
            toastShow(toast, 'error', 'LLenar todos los campos Requeridos')
        } else {
            let message = <div>¿Está seguro que desea guardar la información?</div>
            confirmDialog({
                message: message,
                header: 'Confirmación',
                icon: 'pi pi-exclamation-triangle',
                accept: async () => {
                    const result = await putInfoProducto(values)

                    if (result) {
                        toastShow(toast, 'success', 'Información Actualizada Correctamente')
                        obtenerInformacion(IdProducto)
                        refresh();
                        hideDialog()
                    } else {
                        toastShow(toast, 'error', 'Ocurrio un error al actualizar la información')
                    }


                }, reject: () => { }
            })
        }
    }
    return (
        <div>
            <div className='d-flex flex-row pt-4 justify-content-between '  >
                <div id='ModalProductos' >
                    <div className='d-flex flex-row'>
                        <Card
                            titulo='Codigo'
                            contenido={<div style={{width:'15vw'}}>
                                <InputText
                                    value={values.CodigoProducto}
                                    onChange={(e) => handleInputChange(e, 'CodigoProducto')}
                                    style={{ width: '100%' }}
                                    className={classNames({ 'p-invalid': showMessages?.CodigoProducto })}
                                    disabled
                                />
                            </div>
                            }
                        />

                        <Card
                            titulo='Nombre'
                            contenido={<div style={{width:'15vw'}}>
                                <InputText
                                    value={values.NombreProducto}
                                    onChange={(e) => handleInputChange(e, 'NombreProducto')}
                                    style={{ width: '100%' }}
                                    className={classNames({ 'p-invalid': showMessages?.NombreProducto })}
                                    disabled
                                />
                            </div>}
                        />
                    </div>
                    <div className='d-flex flex-row' >
                        <Card
                            titulo='Categoria Finanzas'
                            contenido={<div style={{width:'15vw'}}>
                                <Dropdown
                                    value={values.IdCategoriaFinanzas}
                                    onChange={(e) => {
                                        let filtro = subCategoriasFinanzas.filter((s) => s.IdCategoriaFinanzas === e.value)
                                        setSubCategoriaFiltradas(filtro)
                                        handleInputChange(e, 'IdCategoriaFinanzas')
                                    }}

                                    options={categoriasFinanzas}
                                    optionValue='Id'
                                    optionLabel='Nombre'
                                    style={{ width: '100%' }}
                                    filter filterBy='Nombre'
                                    className={classNames({ 'p-invalid': showMessages?.IdCategoriaFinanzas })}
                                />
                            </div>}
                        />
                        <Card
                            titulo='SubCategoria Finanzas'
                            contenido={<div style={{width:'15vw'}}>
                                <Dropdown
                                    value={values.IdSubCategoriaFinanzas}
                                    onChange={(e) => { handleInputChange(e, 'IdSubCategoriaFinanzas') }}
                                    options={subCategoriasFiltradas}
                                    optionValue='IdSubCategoriaFinanzas'
                                    optionLabel='SubCategoriaFinanzas'
                                    style={{ width: '100%' }}
                                    filter filterBy='SubCategoriaFinanzas'
                                    className={classNames({ 'p-invalid': showMessages?.IdSubCategoriaFinanzas })}

                                />
                            </div>}

                        />
                    </div>
                    {showMessages.General && <div className="p-error">{('Debe Completar todos los campos')}</div>}
                    <div className='footerFormulario2' style={{ height: 50, marginTop: 10 }}>
                        <Button icon='pi pi-times' onClick={hideDialog} label='Cancelar' className='mx-2 p-button-text' />
                        <Button icon='pi pi-check' onClick={() => GuardarInformacion()} label='Guardar' className='p-button-text' />
                    </div>
                </div>
                <div className='mx-5' style={{ width: '20%' }}>
                    {ImagenProducto()}
                </div>
            </div>

        </div>
    )
}

export default ProductoTab
